import * as Common from '@/tenant/common';
// import { __makeTemplateObject } from 'tslib';

export class Matter extends Common.StateObject {
  constructor(){
    super('Matter');
    this.binders.parent = new Common.ModelBinder(Common.Project);
    this.workflowCode="matter";
    this.workflowStateId = 1;//フラグ値を変更;
  }
  public id: number = 0;
  public name: string = '';
  public project: string = '';
  public note: string = '';
  public category: string = '';
  public type: number = 1;
  public pid: string = '';
  public status: number = 1;
  public limitDate: Date = new Date();
  public amount:number=0;
  public fileLocation:string = '';
  public parent: Common.Project = null;

  // public sampleField :number=0;

  public copy():any {
    const temp = super.copy() as Matter;
    temp.id = 0;
    return temp;
  }
}

export class MatterQuery extends Common.LoadQuery {
  constructor(){
    super('MatterQuery', Matter);
    this.sort = 'id';
  }
  
  public category: string = '';
  public type: number = 0;
  public pid: string = '';
  public status: number = 127;
  public today: Date = new Date();
  public limitDateFrom: Date = null;
  public limitDateTo: Date = null;
  public updateOnFrom: Date = null;
  public updateOnTo: Date = null;
  public holder: string = '';
  public id: number = 0;
}

export class MatterMasterQuery extends Common.LoadQuery {
  constructor(){
    super('MatterMasterQuery',Matter);
  }
}

export class MatterCustomReportQuery extends Common.Query {
    constructor(){
        super("MatterCustomReportQuery", null);
    }
    public templateId:number=0;
    public category: string = '';
    public project: string='';
    public pid: string = '';
    public status: number = 127;    
}